import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/layers.css'; // layer order — must precede the kit (see file header)
import '@ofself/shell/styles.css';
import './styles/index.css';
import App from './App';

// Theme is shell-owned: boot.js restores data-rail-skin onto <html> pre-paint,
// and the app's dark palette keys off [data-rail-skin="dark"] (index.css).

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
